import { render, staticRenderFns } from "./vPagination.vue?vue&type=template&id=feeeb5d0&scoped=true"
import script from "./vPagination.vue?vue&type=script&lang=ts"
export * from "./vPagination.vue?vue&type=script&lang=ts"
import style0 from "./vPagination.vue?vue&type=style&index=0&id=feeeb5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feeeb5d0",
  null
  
)

export default component.exports